import VerticalTabs from "common/ComponentSidebar/ComponentSideBar";
import { checkPrivileges } from "Helpers/CheckPrivileges";
import {
  getStationAssignAccountPath,
  getStationAssignUserPath,
  getStationEditPath,
  getStationPlanUsagePath,
  getStationTermsPath,
  useStationRouteContext,
} from "Helpers/stationRoutes";
import { useNavigate } from "react-router-dom";

interface tabProps {
  params: any;
  selectedIndex: number;
}
export default function StationTabs(props: tabProps) {
  const navigate = useNavigate();
  const { stationId, businessId } = useStationRouteContext();
  const handleChangeTabs = (tabId: number) => {
    if (!stationId) return;
    if (tabId === 0) navigate(getStationEditPath(stationId, businessId));
    // else if (tabId === 1) navigate(getStationAssignStorePath(stationId, businessId));
    else if (tabId === 1)
      navigate(getStationAssignAccountPath(stationId, businessId));
    else if (tabId === 2)
      navigate(getStationAssignUserPath(stationId, businessId));
    // else if (tabId === 4) navigate(`/station/assign/bay/${stationId}`);
    // else if (tabId === 5) navigate(`/station/assign/warehouse/${stationId}`);
    else if (tabId === 3)
      navigate(getStationTermsPath(stationId, businessId));
    else if (tabId === 4)
      navigate(getStationPlanUsagePath(stationId, businessId));
  };
  const tabs = [
    { id: 0, title: `edit`, child: <></> },
    // { id: 1, title: `store`, child: <></> },
    { id: 1, title: `account`, child: <></> },
    { id: 2, title: `users`, child: <></> },
    // { id: 4, title: `bay`, child: <></> },
    // { id: 5, title: `warehouse`, child: <></> },
    { id: 3, title: `Terms & Conditions`, child: <></> },
    { id: 4, title: `planUsage`, child: <></> },
  ];
  const disableTabs = tabs
    .map((tab) => tab.id)
    .filter((tabId) => {
      switch (tabId) {
        case 0:
          return !checkPrivileges("ROLE_STATION_UPDATE");
        // case 1:
        //     return !checkPrivileges('ROLE_STATION_STORE_ASSIGN') && !checkPrivileges('ROLE_STATION_STORE_UNASSIGN');
        case 1:
          return (
            !checkPrivileges("ROLE_STATION_BANKACCOUNT_ASSIGN") &&
            !checkPrivileges("ROLE_STATION_BANKACCOUNT_UNASSIGN")
          );
        case 2:
          return (
            !checkPrivileges("ROLE_STATION_USER_ASSIGN") &&
            !checkPrivileges("ROLE_STATION_USER_UNASSIGN")
          );
        // case 4:
        //     return !checkPrivileges('ROLE_STATION_BAY_ASSIGN') && !checkPrivileges('ROLE_STATION_BAY_UNASSIGN');
        // case 5:
        //     return !checkPrivileges('ROLE_STATION_WAREHOUSE_ASSIGN') && !checkPrivileges('ROLE_STATION_WAREHOUSE_UNASSIGN');
        case 3:
          return !checkPrivileges("ROLE_TERMANDCONDITION_VIEW");
        case 4:
          return !checkPrivileges("ROLE_STATION_UPDATE");
        default:
          return false;
      }
    });

  return (
    <>
      <VerticalTabs
        tabs={tabs}
        selectedIndex={props.selectedIndex}
        handleChangeTabs={handleChangeTabs}
        disableTabNo={disableTabs}
      />
    </>
  );
}
